/**
 * `/methodology`, in five languages.
 *
 * One page rather than a family, so there is no slug and no registry — just a
 * path helper and the same lazy per-language loader shape the other content
 * modules use, which keeps four translations out of the bundle that renders the
 * fifth.
 */

import type { ContentLang } from "@fazly/shared/contentLang";

import { en } from "./en";
import type { MethodologyCopy } from "./types";

export function methodologyPath(lang: ContentLang = "en"): string {
  return lang === "en" ? "/methodology" : `/${lang}/methodology`;
}

const LOADERS: Record<ContentLang, () => Promise<MethodologyCopy>> = {
  en: async () => en,
  de: () => import("./de").then((m) => m.de),
  tr: () => import("./tr").then((m) => m.tr),
  pt: () => import("./pt").then((m) => m.pt),
  es: () => import("./es").then((m) => m.es),
};

export function loadMethodology(lang: ContentLang): Promise<MethodologyCopy> {
  return LOADERS[lang]();
}

export type { MethodologyCopy };
